import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import { TelegramStatsStore } from './telegram-stats.store';

const TelegramStatsContext = React.createContext<TelegramStatsStore | null>(null);

export const TelegramStatsProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<TelegramStatsStore>(() => new TelegramStatsStore(navigate));

   return (
      <TelegramStatsContext.Provider value={store}>{children}</TelegramStatsContext.Provider>
   );
};

export const useTelegramStats = () => {
   const ctx = React.useContext(TelegramStatsContext);
   if (!ctx) {
      throw new Error('useTelegramStats must be used inside TelegramStatsProvider');
   }
   return ctx;
};
